@if (showTitleAndCallout()) {
  <h2 class="td-wb-material-address__heading"
      [translate]="titleKey()"></h2>

  <td-wb-call-out class="td-wb-material-address__callout">
    <span [innerHTML]="'tdWb.address.CALLOUT' | tdWbTranslate"></span>
  </td-wb-call-out>
}

@if (isHome()) {
  <p class="td-wb-material-address__info"
     translate="tdWb.address.NOTE"></p>
}

<div [formGroup]="form">
  <!-- STREET NUMBER / STREET NAME / UNIT -->
  <div class="td-wb-material-address__row">
    <mat-form-field class="td-wb-material-address__field">
      <mat-label translate="tdWb.address.STREET_NUM" />
      <input matInput
             [id]="'td-wb-address-street-num-' + usageId()"
             formControlName="streetNumDisplay"
             [name]="'streetNumber-' + usageId()"
             type="text"
             maxlength="20">
      @if (form.controls.streetNumDisplay.touched && form.controls.streetNumDisplay.hasError('required')) {
        <mat-error translate="tdWb.address.validationMsges.streetNum.required" />
      }
    </mat-form-field>

    <mat-form-field class="td-wb-material-address__field">
      <mat-label translate="tdWb.address.STREET" />
      <input matInput
             [id]="'td-wb-address-street-' + usageId()"
             formControlName="streetName"
             [name]="'streetName-' + usageId()"
             type="text"
             maxlength="30">
      @if (form.controls.streetName.touched && form.controls.streetName.hasError('required')) {
        <mat-error translate="tdWb.address.validationMsges.streetName.required" />
      }
    </mat-form-field>

    <mat-form-field class="td-wb-material-address__field td-wb-material-address__field--small">
      <mat-label translate="tdWb.address.OPTIONAL" />
      <input matInput
             [id]="'td-wb-address-unit-' + usageId()"
             formControlName="unitNum"
             [name]="'unitNumber-' + usageId()"
             type="text"
             maxlength="6">
    </mat-form-field>
  </div>

  <!-- CITY / PROVINCE / POSTAL CODE -->
  <div class="td-wb-material-address__row">
    <mat-form-field class="td-wb-material-address__field">
      <mat-label translate="tdWb.address.CITY" />
      <input matInput
             [id]="'td-wb-address-city-' + usageId()"
             formControlName="cityName"
             [name]="'city-' + usageId()"
             type="text"
             autocomplete="address-level2"
             maxlength="30">
      @if (form.controls.cityName.touched && form.controls.cityName.hasError('required')) {
        <mat-error translate="tdWb.address.validationMsges.cityName.required" />
      }
    </mat-form-field>

    <mat-form-field class="td-wb-material-address__field">
      <mat-label translate="tdWb.address.PROVINCE" />
      <mat-select [id]="'td-wb-address-territory-' + usageId()"
                  formControlName="territory"
                  [attr.name]="'province-' + usageId()"
                  [placeholder]="'tdWb.address.PROVINCE_PLACEHOLDER' | tdWbTranslate"
                  [attr.aria-label]="'tdWb.address.PROVINCE' | tdWbTranslate">
        @for (province of provinces; track province.code) {
          <mat-option [value]="province.code">
            <span [innerText]="province.name"></span>
          </mat-option>
        }
      </mat-select>
      @if (form.controls.territory.touched && form.controls.territory.hasError('required')) {
        <mat-error translate="tdWb.address.validationMsges.province.required" />
      }
    </mat-form-field>

    <mat-form-field class="td-wb-material-address__field td-wb-material-address__field--small">
      <mat-label translate="tdWb.address.POSTAL_CODE" />
      <input matInput
             [id]="'td-wb-address-postalcode-' + usageId()"
             formControlName="postalCode"
             [name]="'postalCode-' + usageId()"
             type="text"
             autocomplete="postal-code"
             maxlength="6">
      @if (form.controls.postalCode.touched && form.controls.postalCode.hasError('required')) {
        <mat-error translate="tdWb.address.validationMsges.postalCode.required" />
      }
      @if (form.controls.postalCode.touched && form.controls.postalCode.hasError('invalidPostalCode')) {
        <mat-error translate="tdWb.address.validationMsges.postalCode.invalidPostalCode" />
      }
    </mat-form-field>
  </div>

  @if (showRuralRouteAndPOBox()) {
    <div class="td-wb-material-address__row">
      @if (!isHome()) {
        <mat-form-field class="td-wb-material-address__field">
          <mat-label translate="tdWb.address.PO_BOX_TYPES" />
          <mat-select [id]="'td-wb-address-po-box-type-' + usageId()"
                      formControlName="ruralOrPoBoxType"
                      [attr.name]="'td-wb-address-po-box-type-' + usageId()"
                      [placeholder]="'tdWb.address.PROVINCE_PLACEHOLDER' | tdWbTranslate">
            <mat-option [value]="''">
              <span translate="tdWb.address.PROVINCE_PLACEHOLDER"></span>
            </mat-option>
            @for (type of ruralPoTypes; track type) {
              <mat-option [value]="type">
                <span [translate]="'tdWb.address.' + type"></span>
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field class="td-wb-material-address__field">
        <mat-label [translate]="ruralOrPoBoxLabel()" />
        <input matInput
               [id]="'td-wb-address-pobox-' + usageId()"
               formControlName="ruralOrPoBox"
               [name]="'ruralRoute-' + usageId()"
               type="number"
               [tdWbRuralRoutePoBoxInput]="ruralOrPoBoxTypeValue()">
        @if (form.controls.ruralOrPoBox.touched && form.controls.ruralOrPoBox.hasError('required')) {
          <mat-error translate="tdWb.address.validationMsges.poBoxRuralRoute.required" />
        }
      </mat-form-field>

      <mat-form-field class="td-wb-material-address__field td-wb-material-address__field--small">
        <mat-label translate="tdWb.address.STATION" />
        <input matInput
               [id]="'td-wb-address-station-' + usageId()"
               formControlName="postalStationTxt"
               [name]="'station-' + usageId()"
               type="text"
               maxlength="30">
      </mat-form-field>
    </div>
  }
</div>









